import { render, staticRenderFns } from "./SingleAppointment.vue?vue&type=template&id=704c75fa&"
import script from "./SingleAppointment.vue?vue&type=script&lang=js&"
export * from "./SingleAppointment.vue?vue&type=script&lang=js&"
import style0 from "./SingleAppointment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports